function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.3 11s.334 3.334 1.486 23.362c.237 4.116-5.152 13.971-.152 17.271s9.698-.04 12.752-.376c5.302-.582 8.947-.158 14.171.914 2.487.51 4.463 1.398 7 1.324 2.235-.066 3.846-2.004 6.076-2.162 2 1 3.949 1.722 6 1.238 1.836-.433 4.915-1.886 4.915-3.771 0-.943-.915-1.467-2.915-1.467-.666 0-3.088.136-3.752.076-3.712-.335-5.84-1.426-9.02-3.371-14.228-8.705-18.31-5.803-18.228-13.705l.2-19.334M10 34c-3.735 6.115 2.771 6.505 2.772 6.505",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgFoot = function SvgFoot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFoot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Foot.767fc4bd.svg";
export { ForwardRef as ReactComponent };